import React, { ReactNode, useEffect } from "react";
import { SharedCurrentUser } from "../../lib/types";
import useFlash from "../../lib/useFlash";
import { CurrentUserContext } from "../../lib/CurrentUserContext";

import { newUserDatabaseAuthenticationRegistrationPath, newUserSessionPath } from "../../../../../routes";
import { isShowFloatingRegisterButton } from "../../lib/isShowFloatingRegisterButton";
import Button from "../ui/Button";

import { Box, HStack, Link, Text } from "@chakra-ui/react";
import useGoogleAnalytics from "../../lib/useGoogleAnalytics";

const Application = ({
  children,
  flash = {},
  currentUser = null,
  disableFloatingRegisterButton = false,
}: {
  children: ReactNode;
  flash: Record<string, string>;
  currentUser?: SharedCurrentUser;
  disableFloatingRegisterButton?: boolean;
}) => {
  const showFlash = useFlash();

  useEffect(() => showFlash(flash), [showFlash, flash]);

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const id = hash.substring(1);
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView();
      }
    }
  }, []);

  useGoogleAnalytics();

  return (
    <CurrentUserContext.Provider value={currentUser}>
      <Box>
        {children}
        {isShowFloatingRegisterButton({ currentUser }) && !disableFloatingRegisterButton && (
          <HStack
            justify={"center"}
            py={{ base: 6, md: 5 }}
            bgColor="rgba(0, 0, 0, 0.7)"
            position="sticky"
            bottom={0}
            zIndex={100}
            gap={{ base: 4, md: 8 }}
          >
            <Button
              as="a"
              href={newUserDatabaseAuthenticationRegistrationPath()}
              bgColor="#F4C752"
              border={"none"}
              _hover={{
                bgColor: "#F1B20F",
              }}
            >
              <Text color="textBase">会員登録（無料）</Text>
            </Button>
            <Link color="white" fontSize={"sm"} fontWeight={"bold"} href={newUserSessionPath()}>
              ログインはこちら
            </Link>
          </HStack>
        )}
      </Box>
    </CurrentUserContext.Provider>
  );
};

export default Application;
